(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('miracles-load-more')) {
  customElements.define('miracles-load-more', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const positionReviews = () => {
        const archive = document.getElementById('PreviousReleases-' + this.dataset.section);
        const reviews = document.querySelector('#MainContent > .shopify-section[id$="__1784737587db577137"]');
        if (archive && reviews) archive.before(reviews);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', positionReviews, { once: true });
      } else {
        positionReviews();
      }
      this.button = this.querySelector('[data-load-more]');
      this.status = this.querySelector('[data-load-status]');
      this.button?.addEventListener('click', () => this.loadMore(true));
      const grid = document.getElementById('Slider-' + this.dataset.section);
      if (this.button && grid && grid.children.length < 24 && this.dataset.next) this.loadMore();
    }
    async loadMore(userInitiated = false) {
      if (this.busy || !this.dataset.next) return;
      const grid = document.getElementById('Slider-' + this.dataset.section);
      if (!grid) return;
      this.busy = true;
      this.button.disabled = true;
      const label = this.button.textContent;
      this.button.textContent = this.dataset.loading;
      this.status.textContent = '';
      grid.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(this.dataset.next, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Invalid origin');
        url.searchParams.set('section_id', this.dataset.section);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
        if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = doc.getElementById(grid.id);
        const nextControl = Array.from(doc.querySelectorAll('miracles-load-more')).find(el => el.dataset.section === this.dataset.section);
        if (!nextGrid || !nextControl) throw new Error('Missing collection');
        const existing = new Set(Array.from(grid.children, el => el.id));
        const cards = Array.from(nextGrid.children).filter(el => el.id && !existing.has(el.id));
        const archive = document.getElementById('ArchiveGrid-' + this.dataset.section);
        const nextArchive = doc.getElementById('ArchiveGrid-' + this.dataset.section);
        const archiveIds = new Set(Array.from(archive?.children || [], el => el.id));
        const archivedCards = Array.from(nextArchive?.children || []).filter(el => el.id && !archiveIds.has(el.id));
        for (const card of archivedCards) {
          card.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          card.removeAttribute('data-cascade');
          card.style.removeProperty('--animation-order');
        }
        archive?.append(...archivedCards);
        if (archive?.children.length) document.getElementById('PreviousReleases-' + this.dataset.section).hidden = false;
        for (const card of cards) {
          card.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          card.removeAttribute('data-cascade');
          card.style.removeProperty('--animation-order');
        }
        grid.append(...cards);
        this.dataset.next = nextControl.dataset.next || '';
        grid.closest('slider-component')?.resetPages?.();
        const firstLink = cards[0]?.querySelector('a[href]');
        if (userInitiated) firstLink?.focus({ preventScroll: true });
        this.status.textContent = this.dataset.next ? this.dataset.loaded : this.dataset.complete;
        this.button.hidden = !this.dataset.next;
        if (typeof window.loox?.refresh === 'function') window.loox.refresh();
        this.keepLoading = !!this.dataset.next && (cards.length === 0 || grid.children.length < 24);
      } catch (error) {
        this.status.textContent = this.dataset.error;
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.button.textContent = label;
        grid.removeAttribute('aria-busy');
        if (this.keepLoading) { this.keepLoading = false; this.loadMore(); }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-sold-out-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-sold-out-signup')) {
    customElements.define('mc-sold-out-signup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.productLabel = this.querySelector('[data-mc-signup-product]');
        this.tagsInput = this.querySelector('[data-mc-signup-tags]');
        this.soldOutText = this.dataset.soldOutText.trim().toLowerCase();
        this.baseTags = this.dataset.baseTags;

        document.querySelectorAll('.card-wrapper').forEach((card) => {
          card.querySelectorAll('.card__badge .badge').forEach((badge) => {
            if (badge.textContent.trim().toLowerCase() !== this.soldOutText) return;

            const trigger = document.createElement('button');
            trigger.type = 'button';
            trigger.id = badge.id;
            trigger.className = `${badge.className} mc-sold-out-signup__trigger`;
            trigger.textContent = this.dataset.triggerText;
            badge.replaceWith(trigger);
            this.bindTrigger(trigger);
          });

          card.querySelectorAll('.mc-card-quick-add__trigger:disabled, .quick-add__submit:disabled').forEach((button) => {
            if (button.textContent.trim().toLowerCase() !== this.soldOutText) return;

            button.disabled = false;
            button.type = 'button';
            button.removeAttribute('name');
            button.removeAttribute('data-sold-out-message');
            button.classList.add('mc-sold-out-signup__trigger');
            button.textContent = this.dataset.triggerText;
            this.bindTrigger(button);
          });
        });

        this.querySelector('[data-mc-signup-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        const success = this.querySelector('[data-mc-signup-success]');
        if (success) {
          this.dialog.showModal();
          success.focus();
        }
      }

      bindTrigger(trigger) {
        if (trigger.dataset.mcSignupBound === 'true') return;
        trigger.dataset.mcSignupBound = 'true';
        trigger.addEventListener('click', () => this.open(trigger));
      }

      open(trigger) {
        const card = trigger.closest('.card-wrapper');
        const title = card?.querySelector('.card__heading')?.textContent.trim() || '';
        const productLink = card?.querySelector('a[href*="/products/"]');
        let handle = '';

        if (productLink) {
          const productUrl = new URL(productLink.href, window.location.origin);
          handle = productUrl.pathname.split('/products/')[1]?.split('/')[0] || '';
        }

        this.productLabel.textContent = title;
        this.tagsInput.value = handle ? `${this.baseTags},product-${handle}` : this.baseTags;
        this.dialog.showModal();
        this.querySelector('input[type="email"]')?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-welcome-offer"]) return;
  try {
    
  (() => {
    const dialog = document.getElementById('McWelcomeOffer');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const completedKey = 'mcWelcomeCompleted';
    const dismissedKey = 'mcWelcomeDismissedAt';
    const sessionKey = 'mcWelcomeCartSession';
    const month = 30 * 24 * 60 * 60 * 1000;
    const success = dialog.querySelector('[data-mc-success]');
    const dismissedAt = Number(localStorage.getItem(dismissedKey) || 0);
    const blocked = localStorage.getItem(completedKey) || sessionStorage.getItem(sessionKey) || Date.now() - dismissedAt < month;
    let opened = false;

    const open = () => {
      if (opened || blocked) return;
      opened = true;
      dialog.showModal();
    };

    const dismiss = () => {
      localStorage.setItem(dismissedKey, String(Date.now()));
      dialog.close();
    };

    if (success) {
      localStorage.setItem(completedKey, 'true');
      dialog.showModal();
    } else if (!blocked) {
      const delay = Math.floor(Math.random() * 4001) + 6000;
      window.setTimeout(open, delay);
    }

    dialog.querySelector('[data-mc-close]')?.addEventListener('click', dismiss);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      dismiss();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dismiss();
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.action.includes('/cart/add')) {
        sessionStorage.setItem(sessionKey, 'true');
        if (dialog.open) dialog.close();
      }
    });

    dialog.querySelector('[data-mc-copy]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      await navigator.clipboard.writeText(button.dataset.code || '');
      const label = button.querySelector('small');
      if (label) label.textContent = button.dataset.copiedLabel || 'COPIED';
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
